import React, { useRef } from "react";
import { useState } from "react";
import TabSize from "./TabSize";
import axios from "axios";
import { useEffect } from "react";
import {
  Link,
  useParams,
  useLocation,
  useNavigate,
  NavLink,
} from "react-router-dom";
import Layout from "../component/Layout/Layout";
import parse from "html-react-parser";
//import ProductGallery from "./ProductGallery";
import ProductGallery from "./ProductGalleryVideo";
import ShimmerSingleBox from "../component/ShimmerSingleBox";
import AddtoWishlist from "./AddtoWishlist";
import PriceHtml from "./PriceHtml";
import SocialShare from "./SocialShare";
import {
  useCategoryChildAPI,
  useProductDetails,
} from "../hooks/useAllCategoryData";
import { useCart } from "../context/cart";
import { useAuth } from "../context/auth";
import {
  getFinalPricewithSymbol,
  getPriceSymbole,
  getRoundPrice,
  getPrice,
} from "../Helper";
import { getExchangeRate } from "../Helper";
import { getPriceCurrencyCode } from "../Helper";
import BreadcrumbsProductDetails from "./BreadcrumbsProductDetails";
import Rating from "../rating/Rating";
import Review from "../rating/Review";
import CountdownTimer from "./CountdownTimer";
import AddtoTryOn from "./AddtoTryOn";

function ProductDetail() {
  //console.log(getPriceCurrencyCode);
  let activeClassName = "active";
  let defoltClassName = "";
  const ref = useRef(null);

  const [isActive, setActive] = useState("false");

  const ToggleClass = () => {
    setActive(!isActive);
  };
  const [auth, setAuth] = useAuth();
  const symbol = getPriceSymbole();
  const exchangeRate = getExchangeRate();
  const currencyCode = getPriceCurrencyCode();
  const location = useLocation();
  const [cart, setCart] = useCart();
  const [lauth] = useAuth();
  const path = location.pathname.split("/");
  const [loading, setLoading] = useState(false);
  const [shimmer, setShimmer] = useState("shimmer-active");
  const navigate = useNavigate();
  const [colors, SetColors] = useState([]);
  const [choice, SetChoice] = useState([]);
  const [color_options, Setcolor_options] = useState([]);
  const [variation, SetVariation] = useState([]);
  const [enableAttribute, SetenableAttribute] = useState([]);
  const [selectedAttribute, setSelectedAttribute] = useState([]);
  const [selectedColours, setSelectedColours] = useState([]);
  const [cartqty, setCartQty] = useState(1);
  const [selColourState, setselColourState] = useState("");
  const [finalAmount, setFinalAmount] = useState(0);
  const [customMsg, setCustomMsg] = useState(false);
  const [cartData, SetCartData] = useState([]);
  const [catradded, SetCatradded] = useState(false);
  const [shippingtime, Setshippingtime] = useState("");
  const [categoryData, setCategoryData] = useState({ child_slugs: [] });
  const [showSecondPopup, setShowSecondPopup] = useState(() => {
    const stored = localStorage.getItem("secondPopupShown");
    return stored === null ? true : stored === "true";
  });
  const [welcomeDiscountEnable, setWecomeDiscountEnable] = useState(0);
  let [productDetail, setProductDetail] = useState([]);
  //Query Product Details
  const { isLoading, data: product } = useProductDetails(path);

  let getProductDetail = async (data) => {
    try {
      if (data.id && data.status > 0) {
        if (data.attributes) {
          setProductDetail(data);
          //console.log(data)
        }
        SetChoice(JSON.parse(data.choice_options));
        SetVariation(JSON.parse(data.variation));
        SetenableAttribute(JSON.parse(data.attributes));
        Setcolor_options(JSON.parse(data.color_options));
        Setshippingtime(data.shipping_time);

        /*Set Auto selected first chose options*/
        if (data.variation) {
          var defaultChoice = {};
          var choiceArr = JSON.parse(data.choice_options);
          if (choiceArr.length > 0) {
            for (let j = 0; j < choiceArr.length; j++) {
              // console.log(choiceArr[j])
              var trimArray = choiceArr[j].options.map((element) => {
                return element.trim();
              });
              var firstVal = trimArray.includes("L") ? "L" : trimArray[0];
              defaultChoice = {
                ...defaultChoice,
                [choiceArr[j].name]: firstVal,
              };
            }
          }
          //console.log(defaultChoice)
          setSelectedAttribute(defaultChoice);
        }

        /*Set Auto selected color first options*/
        if (JSON.parse(data.colors).length > 0 && data.colors_name) {
          SetColors(JSON.parse(data.colors));
          setSelectedColours({
            ...selectedColours,
            ["color"]: data.colors_name,
          });
        }

        //FB Pixel Code: ViewContent
        if (typeof window !== "undefined") {
          if (window.fbq != null) {
            window.fbq("track", "ViewContent", {
              content_name: data.name,
              content_category: data?.catagories
                ? JSON.parse(data.catagories)[0]["name"]
                : "",
              content_ids: data.code,
              content_type: "product",
              value: getFinalPricewithSymbol(
                data.discount,
                data.discount_type,
                data.unit_price
              ),
              currency: "INR",
            });
          }
        }
      } else {
        navigate("/notfound", { replace: true });
      }

      setLoading(false);
      setShimmer("");
    } catch (error) {
      throw error;
    }
  };
  //console.log('productsss',productDetail)
  const handleChangeAttribute = (e) => {
    const cvalue = e.target.value.replace(/\s+/g, "");
    setSelectedAttribute({
      ...selectedAttribute,
      [e.target.name]: cvalue,
    });

    if (e.target.name === "choice_2" && cvalue === "CUSTOMTAILORED") {
      setTimeout(function () {
        ref.current?.scrollIntoView({ behavior: "smooth" });
      }, 700);

      setCustomMsg(true);
    } else {
      setCustomMsg(false);
    }
    if (variation.length > 0) {
      getVariantPrice();
    }
  };

  const handleChangeColors = (e) => {
    const value = e.target.value;
    //const value = 'ForestGreen';
    // alert(e.target.name + '==='+ e.target.value)
    setSelectedColours({
      ...selectedColours,
      [e.target.name]: value,
    });
    if (colors.length > 0) {
      getVariantPrice();
    }
    //console.log(selectedColours);
  };

  let getVariantPrice = (k) => {
    /* console.log('------')
    console.log(selectedAttribute) */
    SetCatradded(false);
    var NoOfAttributeActive = enableAttribute.length;
    var NoOfSelectedAttribute = Object.keys(selectedAttribute).length;
    var selectedColourOption;
    var error = true;

    /*  alert(NoOfAttributeActive);
    alert(NoOfSelectedAttribute); */

    selectedColourOption =
      colors.length < 1 && selectedColours.length < 1 ? "" : selectedColours;
    //console.log(selectedColourOption)

    //For color option selected of not and if color option is enable
    /* if (colors.length > 0 && selectedColours.length < 1) {
      alert("Please Select Color Options");
      error = false;
    }

    //For attribute option not selected.
    if (NoOfAttributeActive !== NoOfSelectedAttribute) {
      alert("Please Select Options");
      error = false;
    }
 */
    if (error) {
      var selAtt = Object.values(selectedAttribute);

      selAtt = selAtt.sort();
      selAtt = selAtt.join("-");
      var selSize = selAtt;
      if (selectedColourOption) {
        setselColourState(selectedColours.color);
        selAtt = selectedColours.color + "-" + selAtt;
      }

      let filtered = [];
      for (let j = 0; j < variation.length; j++) {
        if (selAtt === variation[j].type) {
          filtered.push(variation[j]);
        }
      }
      //console.log(selAtt);
      var finalCartPri = finalAmount;
      //return false;
      /*  const filtered = variation.filter(selvar => selvar.sku.includes(selAtt)); */
      if (filtered.length > 0) {
        setFinalAmount(filtered[0].price * cartqty);
        //console.log(filtered[0].shipping_time);
        Setshippingtime(filtered[0].shipping_time);
        if (productDetail.discount !== 0) {
          finalCartPri = Math.round(
            filtered[0].price -
            ((filtered[0].price * productDetail.discount) / 100) * cartqty
          );
        } else {
          finalCartPri = filtered[0].price * cartqty;
        }
      }

      var sel_data = {
        ["product_id"]: productDetail.id,
        ["price"]: finalCartPri,
        ["choices"]: selectedAttribute,
        ["variant"]: selAtt,
        ["variations"]: { color: selectedColours.color, Size: selSize },
        ["color"]: JSON.parse(productDetail.colors)[0],
      };
      SetCartData({
        ...cartData,
        ...sel_data,
      });
    }
  };

  let AddToCart = (redirect) => {
    getProductDetail();
    //alert(finalAmount);

    const c_data = {
      ...cartData,
      ["customer_id"]: lauth?.user ? lauth.user.id : 0,
      ["quantity"]: cartqty,
      ["slug"]: productDetail.slug,
      ["name"]: productDetail.name,
      ["thumbnail"]: productDetail.thumbnail,
    };
    SetCartData(c_data);

    //console.log("c_data", c_data);
    const addCarttoDatabase = async (dataArr) => {
      if (dataArr.customer_id !== "") {
        let cart_data = {
          id: dataArr.product_id,
          product_id: dataArr.product_id,
          color: dataArr.color,
          choice_2: dataArr.variations.Size,
          quantity: dataArr.quantity,
          customer_id: dataArr.customer_id,
          price_data: { currency: symbol, exchange_rate: exchangeRate },
        };

        try {
          let { data } = await axios.post(
            `${process.env.REACT_APP_API_URL}/cart/add`,
            cart_data
          );
          // console.log(data); return false;
          if (data?.status) {
            return data;
          }
        } catch (error) {
          console.log(error);
        }
      }
    };

    //let existingCartItem = localStorage.getItem("cart");
    let existingCartItem = cart
      ? cart
      : JSON.parse(localStorage.getItem("cart"));
    //console.log('cart cc', existingCartItem)
    if (existingCartItem) {
      var exist = false;
      const filtered = existingCartItem.filter((element, index, array) => {
        if (
          String(element.variant) === String(c_data.variant) &&
          element.product_id === c_data.product_id
        ) {
          exist = true;
        }
      });
      if (exist) {
        if (redirect) {
          navigate("/checkout");
        } else {
          alert("Already Added in cart");
        }
      } else {
        existingCartItem = [...existingCartItem, c_data];
        localStorage.setItem("cart", JSON.stringify(existingCartItem));
        setCart(existingCartItem);
        if (redirect) {
          navigate("/checkout");
        }

        SetCatradded(true);
        addCarttoDatabase(c_data);
      }
    } else {
      localStorage.setItem("cart", JSON.stringify([c_data]));
      setCart([c_data]);
      if (redirect) {
        navigate("/checkout");
      }
      SetCatradded(true);
      addCarttoDatabase(c_data);
    }
    if (typeof window !== "undefined") {
      if (window.fbq != null) {
        window.fbq("track", "AddToCart", {
          content_ids: productDetail.code,
          content_name: productDetail.name,
          content_type: "product",
          value: c_data.price,
          currency: "INR",
        });
      }
    }

    // console.log(c_data)
  };
  let activeReadyToShip = (curSize) => {
    //console.log('object',curSize)

    let filtered = [];
    for (let j = 0; j < variation.length; j++) {
      if (curSize === variation[j].type) {
        filtered.push(variation[j]);
        if (variation[j].shipping_time === "Within 7 days") {
          return "rtd-light";
        } else {
          return "";
        }
      }
    }
    //  console.log(filtered)
  };
  useEffect(() => {
    setLoading(true);
    if (!isLoading) {
      getProductDetail(product);
      // console.log(product)
    }
    //eslint-disable-next-line
  }, [product]);

  useEffect(() => {
    //console.log(selectedAttribute)
    // console.log(cartData)
    if (variation.length > 0) {
      getVariantPrice();
      // AddToCart();
    }
    //eslint-disable-next-line
  }, [selectedAttribute, selectedColours]);

  useEffect(() => {
    //eslint-disable-next-line
  }, [cart]);

  const getWelComeDiscount = async () => {
    let { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/static/welcomediscount`
    );
    if (data?.status) {
      setWecomeDiscountEnable(data?.status);
    }
  };
  useEffect(() => {
    if (auth?.user?.id) {
      getWelComeDiscount();
    }
    //eslint-disable-next-line
  }, [auth?.user?.id]);



  // Show the second popup 1 minute (60,000ms) after closing the first one
  /* useEffect(() => {
    let timer;
    const secondPopupShown = localStorage.getItem("secondPopupShown");
    if (!showPopup && localStorage.getItem("popupShown") === "true" && !secondPopupShown && auth?.user?.id) {
        timer = setTimeout(() => {
            setShowSecondPopup(true);
            localStorage.setItem("secondPopupShown", "true");
        }, 6000); // 60 seconds
    }
    return () => clearTimeout(timer);
}, [showPopup]); */

  const handleCLoseSecondPopup = () => {
    setShowSecondPopup(false);
    localStorage.setItem("secondPopupShown", "false");
  };
  const objectInRowByKeys = (value) => {
    const filtered = variation.filter((element) => element.type === value);
    if (filtered.length > 0 && filtered[0].qty < 1) {
      return 1;
    }
    return 0;
  };
  //console.log(JSON.parse(productDetail.images)[0])
  var fbPrice = 0;
  let fbGraphData = {};
  if (productDetail?.unit_price !== "") {
    /* fbPrice =  getRoundPrice(getFinalPricewithSymbol(productDetail.discount,productDetail.discount_type,productDetail.unit_price));  */

    fbPrice = getFinalPricewithSymbol(
      productDetail.discount,
      productDetail.discount_type,
      productDetail.unit_price
    );

    if (!isNaN(fbPrice)) {
      //fbPrice = getPrice(fbPrice,false);
      fbGraphData = {
        id: productDetail?.code,
        availability:
          productDetail.current_stock > 0 ? "in stock" : "out of stock",
        amount: fbPrice,
        currency: "INR",
      };
    }
  }

  const getCategories = (categories) => {
    if (typeof categories === "string") {
      try {
        return JSON.parse(categories);
      } catch (error) {
        console.error("Invalid JSON format in categories:", error);
        return [];
      }
    }
    return Array.isArray(categories) ? categories : [];
  };

  // Ensure `productDetail` is defined before using it
  const categories = getCategories(productDetail?.catagories);

  const categorySlug = categories?.[0]?.slug || null;

  const { data } = useCategoryChildAPI(categorySlug || "");

  useEffect(() => {
    //console.log("Received API Data:", data);
    if (data) {
      setCategoryData(data);
    }
  }, [data]);


 

  return (
    <Layout
      productTag={fbGraphData}
      title={
        productDetail.meta_title ? productDetail.meta_title : productDetail.name
      }
      description={
        productDetail.meta_description
          ? productDetail.meta_description
          : productDetail.name
      }
      keywords={productDetail.meta_keywords ? productDetail.meta_keywords : ""}
      image={
        productDetail.images
          ? `${process.env.REACT_APP_API_ROOT}/storage/app/public/product/${JSON.parse(productDetail.images)[0]
          }`
          : ""
      }
    >
      <div
        className="site-content-wrap product-list product-detail-page-wrap"
        id={productDetail.id ? "page_" + productDetail.id : ""}
      >
        <div className="container">
          <div className="row">
            {productDetail?.is_friday_sale === 1 && (
              <div className="col-md-12 friday-banner">
                <img
                  src="../images/friday_sale_banner_product_page.jpg"
                  alt="Friday Sale Banner"
                />
              </div>
            )}
            <div className="col-md-12 breadcrumb">
              <ul>
                <BreadcrumbsProductDetails
                  categoryData={categoryData || ""}
                  catagories={categories}
                  product={productDetail?.name || ""}
                />
              </ul>
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12 mb-40 custom_gallery">
              {loading ? (
                <div className="products-gallery">
                  {Array.from({ length: 4 }, (_, index) => (
                    <ShimmerSingleBox
                      key={index}
                      CustomStyle={{ height: "475px" }}
                    />
                  ))}
                </div>
              ) : (
                <ProductGallery
                  key="1"
                  images={productDetail.images}
                  short_video={productDetail.short_video}
                  long_video={productDetail.long_video}
                  discount={productDetail.discount}
                  featured={productDetail.featured}
                />
              )}
            </div>
            <div className="col-md-6 col-sm-12 col-xs-12 mb-40">
              <div className="product-details">
                <SocialShare />
                <h1 className="short-desc-box" shimmer={shimmer}>
                  <p>{productDetail.name}</p>
                </h1>
                <h6 className="sku-box" shimmer={shimmer}>
                  Item Code: {productDetail.code}
                </h6>
                {productDetail?.reviews_count > 0 && (
                  <Rating
                    totCount={productDetail?.reviews_count}
                    reviews={productDetail?.reviews}
                    reviewlink="true"
                  />
                )}
                <div className="product-size-tab has-divider" shimmer={shimmer}>
                  {colors.length > 0 && productDetail.colors_name && (
                    <>
                      <h3 style={colors.length === 1 && { display: "none" }}>Choose Color:</h3>
                      <div className="tab-nav" style={colors.length === 1 && { display: "none" }}>
                        <ul className="size-box">
                          {colors &&
                            colors?.map((k, i) => {
                              return (
                                <li key={i}>
                                  <input
                                    type="radio"
                                    name="color"
                                    id={"color_" + i}
                                    value={productDetail.colors_name}
                                    onChange={handleChangeColors}
                                    checked={
                                      selectedColours["color"] ===
                                      productDetail.colors_name
                                    }
                                  />
                                  <label
                                    for={"color_" + i}
                                    style={{ background: k }}
                                  ></label>
                                </li>
                              );
                            })}
                        </ul>
                      </div>
                    </>
                  )}

                  {/* Otions start   */}
                  {choice &&
                    choice?.map((key, val) => {
                      var sortArr = key.options.sort((a, b) => {
                        var sortingArr = [
                          "XS",
                          "S",
                          "M",
                          "L",
                          "XL",
                          "2XL",
                          "3XL",
                          "4XL",
                          "5XL",
                          "6XL",
                          "CUSTOM TAILORED",
                        ];
                        return (
                          sortingArr.indexOf(a.trim()) -
                          sortingArr.indexOf(b.trim())
                        );
                      });
                      return (
                        <>
                          <h3>Choose {key.title}:</h3>
                          <div className="tab-nav">
                            <ul className="size-box">
                              {key.options &&
                                sortArr?.map((k, i) => {
                                  return (
                                    <li
                                      key={i}
                                      className={`${activeReadyToShip(
                                        productDetail?.colors_name +
                                        "-" +
                                        k.trim()
                                      )}  ${variation?.length > 0 &&
                                          selColourState &&
                                          objectInRowByKeys(
                                            selColourState +
                                            "-" +
                                            k.trim().replace(/\s+/g, "")
                                          ) &&
                                          k.trim() === "CUSTOM TAILORED"
                                          ? "disabled"
                                          : ""
                                        }`}
                                    >
                                      <input
                                        type="radio"
                                        name={key.name}
                                        disabled={
                                          variation?.length > 0 &&
                                          selColourState &&
                                          objectInRowByKeys(
                                            selColourState +
                                            "-" +
                                            k.trim().replace(/\s+/g, "")
                                          )
                                        }
                                        id={key.name + "_" + k.trim()}
                                        checked={
                                          selectedAttribute[key.name] ===
                                          k.trim().replace(/\s+/g, "")
                                        }
                                        onChange={handleChangeAttribute}
                                        value={
                                          selectedAttribute[key.name] &&
                                            selectedAttribute[key.name] ===
                                            k.trim()
                                            ? selectedAttribute[key.name]
                                            : k.trim()
                                        }
                                      />
                                      <label for={key.name + "_" + k.trim()}>
                                        {k.trim()}
                                      </label>
                                    </li>
                                  );
                                })}
                              {key.name === "choice_2" ? (
                                <li>
                                  <a
                                    href="#tab-panel-box"
                                    className="size-chart"
                                  >
                                    Size Chart
                                  </a>
                                </li>
                              ) : (
                                ""
                              )}
                            </ul>
                          </div>
                        </>
                      );
                    })}
                  {finalAmount && (
                    <PriceHtml
                      pdata={{
                        discount: productDetail.discount,
                        discount_type: productDetail.discount_type,
                        price: finalAmount,
                        symbol: symbol,
                        divclass: "price-box",
                        shipping_time: shippingtime,
                        pagefrom: "productDetails",
                        coupon_message: productDetail.coupon_message,
                        is_details_page: 1,
                        sku: productDetail.code,
                        is_friday_sale: productDetail.is_friday_sale,
                      }}
                      welcomeDiscountEnable={welcomeDiscountEnable}
                      auth={auth}
                    />
                  )}
                  <div className="add-cart">
                    <input
                      type="hidden"
                      id=""
                      className="input-text qty text"
                      name="quantity"
                      value="1"
                      size="4"
                      min="1"
                      max=""
                      step="1"
                      placeholder=""
                      inputmode="numeric"
                      autocomplete="off"
                    />
                    {productDetail?.current_stock < 1 ? (
                      <span className="sold-out-text">SOLD OUT</span>
                    ) : (
                      <>
                        {finalAmount && !customMsg && productDetail?.is_friday_sale != 1 &&(
                          <button
                            type="button"
                            onClick={(e) => AddToCart()}
                            className={`cart-btn outline-btn ${catradded ? "added" : ""
                              }`}
                            disabled={productDetail?.current_stock < 1}
                          >
                            ADD TO CART
                          </button>
                        )}
                        {!customMsg && (
                          <button
                            type="button"
                            onClick={(e) => {
                              if (lauth?.user) {
                                AddToCart("checkout");
                              } else {
                                AddToCart("/loginsignup");
                              }
                            }}
                            className={`cart-btn ${catradded ? "added" : ""}`}
                            disabled={productDetail?.current_stock < 1}
                          >
                            BUY NOW
                          </button>
                        )}
                        <AddtoTryOn p_id={productDetail.id} />
                        {productDetail?.is_friday_sale != 1 && (
                        <AddtoWishlist p_id={productDetail.id} />
                        )}
                      </>
                    )}
                  </div>
                   
                  
                  
                </div>

                



                {color_options.length > 1 && (
                  <div className="related-product has-divider">
                    <h5>Color Options</h5>
                    <nav>
                      <ul>
                        {color_options?.map((key, i) => {
                          return (
                            <li key={i}>
                              <NavLink
                                className={({ isActive }) =>
                                  isActive ? activeClassName : defoltClassName
                                }
                                to={`/product/${key.slug}`}
                              >
                                <img
                                  src={`${process.env.REACT_APP_API_ROOT}/storage/app/public/product/thumbnail/${key.images}`}
                                  alt=""
                                />
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </nav>
                  </div>
                )}
                {customMsg && (
                  <div
                    className="short-desc custom-box ship-box no-icons newdes-box"
                    id="custom-size"
                    style={{ display: "block" }}
                  >
                    <span className="custom-box" ref={ref}></span>
                    {/* <ul>
                            <li>We would be delighted to customize this garment to your exact measurements.</li>
                            <li>To place a ‘Custom Tailored’ order, please email us at <Link target="_blank" to="mailto:customercare@chaashnicouture.com">customercare@chaashnicouture.com</Link> or <Link target="_blank" to={`https://wa.me/+91919582475486?text=Hello%2C+I+have+a+query+regarding+custom+tailored+${productDetail.code}`} className="custom-whatapp-icon">WhatsApp us</Link>. Kindly include the 'Item Code' (mentioned above) and your preferred delivery date in your message.</li>
                            <li>Our delivery timeline for 'Custom Tailored' orders ranges from 3 to 8 weeks, depending on the complexity of the design. We will confirm the exact timeframe before officially accepting your order.</li>
                            <li>If you require any additional customizations, please feel free to let us know. Kindly note that the garment price may vary based on the requested customizations or size adjustments.</li>
                            <li>Once your 'Custom Tailored' order is placed, you will need to enter your measurements in the <Link target="_blank" to="/measurements">‘My Measurements’</Link> section. A helpful DIY video in that section will guide you through the process.</li>
                            <li>For more information, <Link target="_blank" to="/custom-tailoring">click here</Link></li>
                        </ul> */}
                    <ul>
                      <li>Same style as per your measurements?</li>
                      <li>Same style in a bespoke color?</li>
                      <li>Early delivery?</li>
                      <li>International delivery?</li>
                      <li>Live product preview?</li>
                      <li>Any other questions?</li>
                    </ul>
                    <div className="whatup-box">
                      <Link
                        target="_blank"
                        to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+custom+tailored+${productDetail.code}`}
                        className="custom-whatapp-icon"
                      >
                        CHAT WITH US
                      </Link>
                    </div>
                  </div>
                )}
                <div className="product-description-confidence">
                  <div className="product-description-box">
                    <h5>PRODUCT DESCRIPTION</h5>
                    <div className="product-description" shimmer={shimmer}>
                      {productDetail.details
                        ? parse(productDetail.details)
                        : ""}
                    </div>
                    <div
                      className="about-product-description"
                      shimmer={shimmer}
                    >
                      <ul>
                        <li>
                          <span>Fabric: </span>
                          {productDetail.fabric}
                        </li>
                        <li>
                          <span>Embroidery: </span>
                          {productDetail.embroidery}
                        </li>
                        <li>
                          <span>Care Instruction: </span>
                          {productDetail.care}
                        </li>
                        <li>
                          <span>Fit: </span>
                          {productDetail.fit}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="whatsapp-box has-divider">
                  <span>
                    <strong>Questions or Customisations?</strong>{" "}
                    <Link
                      to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+I+have+a+query+regarding+${productDetail.code}.`}
                      rel="noopener noreferrer"
                      className="whatapp-icon-img"
                      target="_blank"
                    >
                      <u>Message Us</u>
                    </Link>{" "}
                    or get on a{" "}
                    <Link
                      to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}?text=Hello%2C+Can+i+view+this+item+${productDetail.code}+on+a+video+call%3F`}
                      rel="noopener noreferrer"
                      className="whatapp-icon-img-call"
                      target="_blank"
                    >
                      <u>Video Call</u>
                    </Link>{" "}
                    with our friendly Style Executive.
                  </span>
                </div>

                <div className="chaashni-product has-divider">
                  <picture>
                    <source
                      media="(min-width:768px)"
                      srcSet="../images/Product-Page-Icons-v3.svg"
                    />
                    <source
                      media="(min-width:1px)"
                      srcSet="../images/Product-Page-Mobile-Icons-5.svg"
                    />
                    <img src="../images/Product-Page-Icons-v3.svg" alt="" />
                  </picture>
                </div>

                <div className="product-description-confidence tab-panel-main has-divider">
                  <span id="tab-panel-box" />
                  <div className="product-description-box">
                    <h5>SIZE CHART</h5>
                    <div className="tab-pane-size">
                      <div className="size-left">
                        <TabSize />
                        <div className="note-box">
                          <p>
                            <span>Note:</span> This is a standard size guide for
                            the basic body measurements. Length of garments may
                            vary as per style and type.
                          </p>
                        </div>
                        <div className="measurements-box">
                          <img src="../images/video-call-blue.png" alt="" />
                          <Link to="/measurements" target="_blank">
                            How to take Measurements
                          </Link>
                        </div>
                      </div>
                      <div className="size-right">
                        <img src="../images/measurement-img.png" alt="img" />
                      </div>
                    </div>
                  </div>
                </div>
                {productDetail?.reviews_count > 0 && (
                  <div className="review-box has-divider">
                    <Review
                      totCount={productDetail?.reviews_count}
                      reviews={productDetail?.reviews}
                    />
                  </div>
                )}
                <div className="product-description-confidence borderno">
                  <p className="useful-links">
                    <span>Useful Links: </span>{" "}
                    <Link to="/pages/returns-exchanges-and-cancellations">
                      Returns, Exchanges and Cancellations
                    </Link>{" "}
                    |{" "}
                    <Link to="/pages/shipping-information">
                      Shipping Information
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* {auth?.user?.id &&
        welcomeDiscountEnable === 1 &&
        auth?.user?.welcome_discount_use !== 1 && (
          <>
            {showSecondPopup}
            {showSecondPopup && (
              <div className="small-popup-box tick-tock-popup-new">
                <div className="small-popup">
                  <span
                    className="close-popup"
                    onClick={handleCLoseSecondPopup}
                  >
                    &times;
                  </span>
                  <div className="small-first-popup">
                    <p>
                      Tick-tock ⏳<br /> Your <strong>5% Bonus Off </strong> is
                      Live! <br /> Use it before it's gone in 1 hour!
                    </p>
                  </div>
                </div>
                <div className="small-popup-overloay"></div>
              </div>
            )}
          </>
        )} */}


    </Layout>
  );
}

export default ProductDetail;
